import React from 'react';
import { CheckboxLabel, StyledCheckbox, OptionsBar } from './OperationsForCargoPanel.styles';

interface OptionsBarSectionProps {
    showTransit: boolean;
    showStowageItems: boolean;
    onToggleTransit: (checked: boolean) => void;
    onToggleStowageItems: (checked: boolean) => void;
}

const OptionsBarSection: React.FC<OptionsBarSectionProps> = ({ showTransit, showStowageItems, onToggleTransit, onToggleStowageItems }) => {
    return (
        <OptionsBar>
            <CheckboxLabel>
                <StyledCheckbox type="checkbox" checked={showTransit} onChange={(e) => onToggleTransit(e.target.checked)} />
                Show Transit Operations
            </CheckboxLabel>
            <CheckboxLabel>
                <StyledCheckbox type="checkbox" checked={showStowageItems} onChange={(e) => onToggleStowageItems(e.target.checked)} />
                Show Stowage Items
            </CheckboxLabel>
        </OptionsBar>
    );
};

export default OptionsBarSection;
